import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Calendar, User, ArrowLeft } from "lucide-react";
import PageHero from "@/components/shared/PageHero";
import api from "@/lib/api";

function renderContent(text) {
  const parts = text.split("\n\n");
  return parts.map((p, i) => {
    const html = p.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    if (p.startsWith("- ")) {
      const items = p.split("\n").map((line) => line.replace(/^- /, ""));
      return (
        <ul key={i} className="list-disc pl-6 space-y-2 text-foreground/80 leading-relaxed">
          {items.map((it, k) => <li key={k} dangerouslySetInnerHTML={{ __html: it }} />)}
        </ul>
      );
    }
    return <p key={i} className="text-foreground/80 leading-relaxed text-base md:text-lg" dangerouslySetInnerHTML={{ __html: html }} />;
  });
}

export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/blogs/${slug}`).then((r) => setBlog(r.data)).catch(() => setBlog(null)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="py-40 text-center tracking-widest uppercase text-xs text-foreground/60">Loading…</div>;
  if (!blog) return (
    <div className="py-40 text-center">
      <p className="section-label mb-3">404</p>
      <h2 className="serif-display text-4xl">Article not found</h2>
      <Link to="/blogs" className="mt-6 inline-block text-gold tracking-wider uppercase text-xs">Back to journal →</Link>
    </div>
  );

  return (
    <div>
      <PageHero
        label="Journal"
        title={blog.title}
        breadcrumbs={[{ label: "Blogs", to: "/blogs" }, { label: blog.title.substring(0, 40) + (blog.title.length > 40 ? "…" : "") }]}
      />
      <article className="py-14">
        <div className="mx-auto max-w-3xl px-4 md:px-8">
          <div className="flex items-center gap-5 text-xs tracking-widest uppercase text-foreground/60 mb-8">
            <span className="flex items-center gap-2"><Calendar size={12} />{new Date(blog.publish_date).toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" })}</span>
            <span className="flex items-center gap-2"><User size={12} />{blog.author}</span>
          </div>
          {blog.cover_image && (
            <div className="aspect-[16/9] rounded-md overflow-hidden mb-10 border border-border/60">
              <img src={blog.cover_image} alt={blog.title} className="w-full h-full object-cover" />
            </div>
          )}
          {blog.excerpt && <p className="text-xl text-foreground/80 font-serif italic mb-8 leading-relaxed">{blog.excerpt}</p>}
          <div className="space-y-6">{renderContent(blog.content)}</div>
          <div className="mt-14 pt-8 border-t border-border/60">
            <Link to="/blogs" className="inline-flex items-center gap-2 text-xs tracking-wider uppercase text-gold hover:underline">
              <ArrowLeft size={14} /> Back to Journal
            </Link>
          </div>
        </div>
      </article>
    </div>
  );
}
